<template>
  <div class="col-sm-8 col-12">
    <!-- Self Employed additional fields -->
    <v-row
      v-if="row.se"
      id="SelfEmployed"
      class="mt-n3"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <div style="width:90%; margin:0;">
          <v-text-field
            v-model="payNameOption"
            label="Sole Trader Name"
            :rules="[...Rules.required, ...Rules.string, ...Rules.max(payNameOption, 30)]"
            :disabled="disabled"
            counter="30"
            filled
          />
        </div>
        <div class="sole_trader_tooltip">
          <v-tooltip
            top
          >
            <template v-slot:activator="{on}">
              <v-icon
                v-on="on"
              >
                mdi-help-circle
              </v-icon>
            </template>
            <span> {{ tooltip.soleTrader.text }} </span>
          </v-tooltip>
        </div>
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="payNumberOption"
          label="Unique Taxpayer Reference (UTR)"
          :rules="[...Rules.required, ...Rules.digits(10)]"
          :disabled="disabled"
          counter="10"
          filled
        />
      </v-col>
      <v-col
        cols="12"
      >
        <v-radio-group
          v-model="schemeOption"
          class="ma-0 pa-0"
          :disabled="disabled"
          row
          mandatory
        >
          <v-radio
            label="Construction Industry Scheme (CIS)"
            class="mr-8 mb-3"
          />
          <v-radio
            label="Other"
            class="mb-3"
          />
        </v-radio-group>
      </v-col>
    </v-row>
    <!-- Partnership additional fields -->
    <v-row
      v-if="row.p"
      id="Partnership"
      class="mt-n3"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="payNameOption"
          label="Partnership Name"
          :rules="[...Rules.required, ...Rules.string, ...Rules.max(payNameOption, 30)]"
          :disabled="disabled"
          counter="30"
          filled
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="payNumberOption"
          label="Unique Taxpayer Reference (UTR)"
          :rules="[...Rules.required, ...Rules.digits(10)]"
          :disabled="disabled"
          counter="10"
          filled
        />
      </v-col>
    </v-row>
    <!-- Limited Liability Partnership additional fields -->
    <v-row
      v-if="row.llp"
      id="LimitedLiabilityPartnership"
      class="mt-n3"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="payNameOption"
          label="Limited Liability Partnership Name"
          :rules="[...Rules.required, ...Rules.string, ...Rules.max(payNameOption, 30)]"
          :disabled="disabled"
          counter="30"
          filled
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <!-- CRN -->
        <div
          v-if="useCrn"
          class="d-flex"
        >
          <v-text-field
            v-model="payNumberOption"
            class="mr-2"
            label="Company Registration Number"
            :rules="[...Rules.required, ...Rules.crnAlt]"
            :disabled="disabled"
            counter="10"
            filled
          />
          <v-btn
            title="switch to UTR"
            small
            outlined
            fab
            color="primary"
            :disabled="disabled"
            @click="toggleUseCrn()"
          >
            <v-icon>mdi-cached</v-icon>
          </v-btn>
        </div>
        <!-- UTR -->
        <div
          v-else
          class="d-flex"
        >
          <v-text-field
            v-model="payNumberOption"
            class="mr-2"
            label="Unique Taxpayer Reference (UTR)"
            :rules="[...Rules.required, ...Rules.digits(10)]"
            :disabled="disabled"
            counter="10"
            filled
          />
          <v-btn
            title="switch to CRN"
            small
            outlined
            fab
            color="primary"
            :disabled="disabled"
            @click="toggleUseCrn()"
          >
            <v-icon>mdi-cached</v-icon>
          </v-btn>
        </div>
      </v-col>
    </v-row>
    <!-- Limited Company additional fields -->
    <v-row
      v-if="row.lc"
      id="LimitedCompany"
      class="mt-n3"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="payNameOption"
          label="Company Name"
          :rules="[...Rules.required, ...Rules.string, ...Rules.max(payNameOption, 30)]"
          :disabled="disabled"
          counter="30"
          filled
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="payNumberOption"
          label="Company Registration Number"
          :rules="[...Rules.required, ...Rules.crn]"
          :disabled="disabled"
          counter="8"
          filled
        />
      </v-col>
    </v-row>
    <!-- Umbrella additional fields -->
    <v-row
      v-if="row.u"
      id="Umbrella"
      class="mt-n3"
    >
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="payNameOption"
          label="Company Name"
          :rules="[...Rules.string, ...Rules.max(payNameOption, 30)]"
          :disabled="disabled"
          counter="30"
          filled
        />
      </v-col>
      <v-col
        cols="12"
        sm="6"
      >
        <v-text-field
          v-model="payNumberOption"
          label="Company Registration Number"
          :rules="[...Rules.numeric, ...Rules.digits(8)]"
          :disabled="disabled"
          counter="8"
          filled
        />
      </v-col>
    </v-row>
  </div>
</template>
<script>
export default {
  name: 'PayTypeComponent',
  props: {
    paytype: {
      type: String,
      default: 'PAYE'
    },
    name: {
      type: String,
      default: null
    },
    number: {
      type: String,
      default: null
    },
    scheme: {
      type: String,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    row: {
      se: false,
      p: false,
      llp: false,
      lc: false,
      u: false
    },
    tooltip: {
      soleTrader: {
        show: false,
        text: 'This is a required field, so if you are unsure of your sole trader name, ' +
            'please just enter your full name.'
      }
    },
    payNameOption: null,
    payNumberOption: null,
    schemeOption: null,
    useCrn: true
  }),
  computed: {
    //
  },
  watch: {
    paytype () {
      this.$emit('payTypeOptionUpdated', this.paytype)
      this.showRow()
    },
    payNameOption () {
      this.$emit('nameOptionUpdated', this.payNameOption)
    },
    payNumberOption () {
      this.$emit('numberOptionUpdated', this.payNumberOption)
    },
    schemeOption () {
      this.$emit('schemeOptionUpdated', this.schemeOption)
    },
    name () {
      this.payNameOption = this.name
    },
    number () {
      this.payNumberOption = this.number
    },
    scheme () {
      this.schemeOption = this.scheme
    }
  },
  created () {
    this.showRow()
    this.payNameOption = this.name
    this.payNumberOption = this.number
    this.schemeOption = this.scheme
    this.useCrn = !/^([0-9]{10}$)/.test(this.payNumberOption)
  },
  methods: {
    showRow () {
      switch (this.paytype) {
        case 'Self-Employed':
          this.resetRows()
          this.row.se = true
          break
        case 'Partnership':
          this.resetRows()
          this.row.p = true
          break
        case 'Limited Liability Partnership':
          this.resetRows()
          this.row.llp = true
          break
        case 'Limited Company':
          this.resetRows()
          this.row.lc = true
          break
        case 'Umbrella':
          this.resetRows()
          this.row.u = true
          break

        default:
          this.resetRows()
          this.resetOptions()
          break
      }
    },
    resetRows () {
      this.row = _.mapValues(this.row, () => false)
    },
    resetOptions () {
      this.$emit('resetOptions')
    },
    toggleUseCrn () {
      this.payNumberOption = null
      this.useCrn = !this.useCrn
    }
  }
}
</script>
<style>
    .sole_trader_tooltip {
        position: relative;
        left: -10px;
        float: right;
        top: -90px;
    }
</style>
